export default __webpack_public_path__ + "static/media/boys.c4804916.webp";